import _ from "lodash";
import WebServices from "../WebServices";
import {
  PROJECTS_ADD,
  PROJECTS_ADD_ERROR,
  PROJECTS_ADD_SUCCESS,
  PROJECTS_FETCH,
  PROJECTS_FETCH_ERROR,
  PROJECTS_FETCH_SUCCESS,
  PROJECTS_SELECT_FUNCTION,
  PROJECTS_SELECT_GBU,
  PROJECTS_SELECT_PROJECT,
  PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS,
  PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_ERROR,
  PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_SUCCESS,
  PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS,
  PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_ERROR,
  PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS,
  PROJECT_EDIT_FUNCTIONS,
  PROJECT_EDIT_FUNCTIONS_SAVE,
  PROJECT_EDIT_FUNCTIONS_SAVE_ERROR,
  PROJECT_EDIT_FUNCTIONS_SAVE_SUCCESS,
  PROJECTS_FETCH_IWPP_APPROVERS,
  PROJECTS_FETCH_IWPP_APPROVERS_ERROR,
  PROJECTS_FETCH_IWPP_APPROVERS_SUCCESS,
  PROCEDURES_SELECT_FUNCTION_AND_PROJECT,
  PROCEDURES_FETCH_SUCCESS,
  PROJECT_FUNCTION_FETCH_DETAILS,
  PROJECT_FUNCTION_FETCH_DETAILS_ERROR,
  PROJECT_FUNCTION_FETCH_DETAILS_SUCCESS,
  PROJECTS_EDIT_MANAGER_OF_FUNCTIONS,
  PROJECT_FUNCTION_IMPORT_PROCEDURES,
  PROJECT_FUNCTION_IMPORT_PROCEDURES_ERROR,
  PROJECT_FUNCTION_IMPORT_PROCEDURES_SUCCESS,
  PROJECTS_DELETE_IWPP_APPROVER,
  PROJECTS_DELETE_IWPP_APPROVER_ERROR,
  PROJECTS_DELETE_IWPP_APPROVER_SUCCESS,
  PROJECTS_UPDATE_IWPP_APPROVERS,
  PROJECTS_UPDATE_IWPP_APPROVERS_ERROR,
  PROJECTS_UPDATE_IWPP_APPROVERS_SUCCESS,
  PROJECTS_UPDATE_PROJECT,
  PROJECTS_UPDATE_PROJECT_SUCCESS,
  PROJECTS_UPDATE_PROJECT_ERROR,
} from "./Types";
import { showSnackBarMessage } from "./AppInfoActions";
import { getProcedureManual } from "./ProcedureManualActions";
import {
  fetchProjectFunctions as fetchMyActionsProjectFunctions,
  selectProject as selectMyActionsProject,
  selectProjectFunction as selectMyActionsProjectFunction,
} from "./ActionsActions";

const saveProjectFunctions = ({ functions, projectId }) => (dispatch, getState) => {
  dispatch({ type: PROJECT_EDIT_FUNCTIONS_SAVE, payload: functions });
  dispatch(editFunctions(false));
  const webServices = new WebServices();

  webServices
    .saveProjectFunctions({ functions, projectId })
    .then((updatedFunctions) => {
      dispatch(showSnackBarMessage("Functions Updated"));

      dispatch({
        type: PROJECT_EDIT_FUNCTIONS_SAVE_SUCCESS,
        payload: { updatedFunctions, projectId },
      });

      dispatch(fetchProjects()).then(() => {
        const { selectedFunction } = getState().projects;
        if (selectedFunction && selectedFunction.id) {
          dispatch(selectFunction(selectedFunction));
        }
      });

      const refreshMyActionsPromise = dispatch(fetchMyActionsProjectFunctions());

      Promise.resolve(refreshMyActionsPromise).then(() => {
        const actionsState = getState().actions;
        const myActionsProject = (actionsState.projectFunctions || []).find(
          (project) => project && project.id === projectId
        );

        if (!myActionsProject) {
          return;
        }

        dispatch(selectMyActionsProject(myActionsProject));

        const refreshedActionsState = getState().actions;
        const refreshedProject = refreshedActionsState.selectedProject;

        if (!refreshedProject || refreshedProject.id !== projectId) {
          return;
        }

        const targetFunction = refreshedProject.functions
          ? refreshedProject.functions.find((fn) => fn && fn.isAssigned)
          : null;
        const fallbackFunction = targetFunction || (refreshedProject.functions ? refreshedProject.functions[0] : null);

        if (fallbackFunction) {
          dispatch(selectMyActionsProjectFunction(fallbackFunction));
        }
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch(showSnackBarMessage("Error Updating Functions"));

      dispatch({ type: PROJECT_EDIT_FUNCTIONS_SAVE_ERROR, payload: error });
    });
};

const selectProject = (project) => (dispatch) => {
  dispatch({ type: PROJECTS_SELECT_PROJECT, payload: project });

  // Only auto-fetch first function details if user explicitly selected project
  // Skip during initial load to improve performance
  if (project.functions && project.functions.length > 0) {
    // Defer the selectFunction call to avoid blocking the UI
    setTimeout(() => {
      dispatch(selectFunction(project.functions[0]));
    }, 100);
  }
};

const selectGbu = (gbu) => (dispatch) => {
  dispatch({ type: PROJECTS_SELECT_GBU, payload: gbu });
  dispatch(fetchIWPPApprovers(gbu.id));

  // Only auto-fetch first function details if user explicitly selected GBU
  // Skip during initial load to improve performance
  if (gbu.functions && gbu.functions.length > 0) {
    // Defer the selectFunction call to avoid blocking the UI
    setTimeout(() => {
      dispatch(selectFunction(gbu.functions[0]));
    }, 100);
  }
};

const fetchIWPPApprovers = (gbuId) => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: PROJECTS_FETCH_IWPP_APPROVERS });

  webServices
    .getIWPPApprovers(gbuId)
    .then((approvers) => {
      dispatch({
        type: PROJECTS_FETCH_IWPP_APPROVERS_SUCCESS,
        payload: approvers,
      });
    })
    .catch((error) => {
      dispatch({ type: PROJECTS_FETCH_IWPP_APPROVERS_ERROR, payload: error });
    });
};

const editFunctions = (canEdit) => ({
  type: PROJECT_EDIT_FUNCTIONS,
  payload: canEdit,
});

const selectFunction = (aFunction, options = {}) => async (dispatch, getState) => {
  const { forceReload = false } = options;
  const {
    selectedProjectOrGbu,
    selectedFunction,
    selectedFunctionDetails,
    updatingProjectDetails,
  } = getState().projects;

  if (!selectedProjectOrGbu) {
    return;
  }

  if (aFunction.id === 0) {
    dispatch({ type: PROJECTS_EDIT_MANAGER_OF_FUNCTIONS });
    return;
  }

  const isSameFunctionSelected =
    selectedFunction && selectedFunction.id === aFunction.id;
  const hasLoadedDetailsForFunction =
    selectedFunctionDetails && selectedFunctionDetails.id === aFunction.id;

  if (!forceReload && isSameFunctionSelected && (updatingProjectDetails || hasLoadedDetailsForFunction)) {
    dispatch({ type: PROJECTS_SELECT_FUNCTION, payload: aFunction });
    return;
  }

  const gbuId = selectedProjectOrGbu.isGbu ? selectedProjectOrGbu.id : null;
  const projectId = !selectedProjectOrGbu.isGbu
    ? selectedProjectOrGbu.id
    : null;

  if (!selectedProjectOrGbu.isGbu) {
    dispatch(
      getProcedureManual({
        projectId: selectedProjectOrGbu.id,
        functionId: aFunction.id,
      })
    );
    dispatch({
      type: PROCEDURES_SELECT_FUNCTION_AND_PROJECT,
      payload: {
        selectedFunction: aFunction,
        selectedProject: selectedProjectOrGbu,
      },
    });
  }

  dispatch({ type: PROJECTS_SELECT_FUNCTION, payload: aFunction });

  dispatch({ type: PROJECT_FUNCTION_FETCH_DETAILS });

  const webServices = new WebServices();

  try {
    // Parallelize all API calls instead of sequential
    let projectFunctionDetails, functionDetails, procedureCategories, functionCategories, projectSpecificProcedures, procedureManual;

    if (!selectedProjectOrGbu.isGbu) {
      // For projects: parallelize all 6 calls
      [projectFunctionDetails, functionDetails, procedureCategories, functionCategories, projectSpecificProcedures, procedureManual] = await Promise.all([
        webServices.getProjectFunctionDetails({
          gbuId,
          projectId,
          functionId: aFunction.id,
        }),
        webServices.getFunctionDetails(aFunction),
        webServices.getProjectFunctionCategories({
          projectId,
          functionId: aFunction.id,
        }),
        webServices.getFunctionCategories(aFunction.id),
        webServices.getProjectSpecificProcedures({
          gbuId,
          projectId,
          functionId: aFunction.id,
        }),
        webServices.getProcedureManual({
          functionId: aFunction.id,
          projectId,
        }),
      ]);

      // Now merge the results after all calls complete
      const projectCategory = _.find(functionCategories, { isProject: true });
      projectFunctionDetails = {
        ...projectFunctionDetails,
        procedureCategories: procedureCategories,
        projectCategory,
      };

      const projectSpecificCorporateProcedures = _.intersectionBy(
        functionDetails.procedures,
        procedureManual.procedures,
        "id"
      );

      dispatch({
        type: PROCEDURES_FETCH_SUCCESS,
        payload: {
          procedures: projectSpecificProcedures,
          isProjectSpecific: true,
          projectSpecificCorporateProcedures,
        },
      });
    } else {
      // For GBU: parallelize both calls
      [projectFunctionDetails, functionDetails] = await Promise.all([
        webServices.getProjectFunctionDetails({
          gbuId,
          projectId,
          functionId: aFunction.id,
        }),
        webServices.getFunctionDetails(aFunction),
      ]);
    }

    dispatch({
      type: PROJECT_FUNCTION_FETCH_DETAILS_SUCCESS,
      payload: projectFunctionDetails,
    });
  } catch (error) {
    dispatch({ type: PROJECT_FUNCTION_FETCH_DETAILS_ERROR, payload: error });
  }
};

const fetchProjects = () => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: PROJECTS_FETCH });

  return webServices
    .getProjects()
    .then((projects) => {
      dispatch({ type: PROJECTS_FETCH_SUCCESS, payload: projects });
    })
    .catch((error) => {
      dispatch({ type: PROJECTS_FETCH_ERROR, payload: error });
    });
};

const importFunctionProcedures = ({ projectId, functionId }) => async (
  dispatch,
  getState
) => {
  let webServices = new WebServices();
  dispatch({ type: PROJECT_FUNCTION_IMPORT_PROCEDURES });

  try {
    const projects = await webServices.importFunctionProcedures({ projectId, functionId });
    dispatch(showSnackBarMessage("Procedures Imported Successfully"));

    dispatch({
      type: PROJECT_FUNCTION_IMPORT_PROCEDURES_SUCCESS,
      payload: projects,
    });

    let selectedFunction = getState().projects.selectedFunction;
    if (selectedFunction && selectedFunction.id) {
      await dispatch(selectFunction(selectedFunction, { forceReload: true }));
      selectedFunction = getState().projects.selectedFunction;
    }

    const { selectedProjectOrGbu, selectedFunctionDetails } = getState().projects;
    const canSyncWorkflow =
      selectedProjectOrGbu &&
      !selectedProjectOrGbu.isGbu &&
      selectedProjectOrGbu.id &&
      selectedFunction &&
      selectedFunction.id &&
      selectedFunctionDetails &&
      Array.isArray(selectedFunctionDetails.workflowSteps);

    if (canSyncWorkflow) {
      const formValues = {
        workflowSteps: selectedFunctionDetails.workflowSteps,
        projectShouldAutoApproveProcedures:
          selectedFunctionDetails.projectShouldAutoApproveProcedures,
      };

      try {
        await dispatch(
          updateProjectWorkflowApprovers(
            formValues,
            selectedProjectOrGbu.id,
            () => { },
            { suppressSuccessMessage: true }
          )
        );
      } catch (workflowSyncError) {
        // Error toast is handled in updateProjectWorkflowApprovers.
      }
    }

    const resolvedProjectId = selectedProjectOrGbu && !selectedProjectOrGbu.isGbu
      ? selectedProjectOrGbu.id
      : null;
    const resolvedFunctionId = selectedFunction && selectedFunction.id
      ? selectedFunction.id
      : null;

    const refreshMyActionsPromise = dispatch(fetchMyActionsProjectFunctions());

    if (resolvedProjectId && resolvedFunctionId) {
      Promise.resolve(refreshMyActionsPromise).then(() => {
        const actionsState = getState().actions;
        const myActionsProject = (actionsState.projectFunctions || []).find(
          (project) => project && project.id === resolvedProjectId
        );

        if (!myActionsProject) {
          return;
        }

        dispatch(selectMyActionsProject(myActionsProject));

        const refreshedActionsState = getState().actions;
        const refreshedProject = refreshedActionsState.selectedProject;

        if (!refreshedProject || refreshedProject.id !== resolvedProjectId) {
          return;
        }

        const myActionsFunction = refreshedProject.functions
          ? refreshedProject.functions.find((fn) => fn && fn.id === resolvedFunctionId)
          : null;
        const fallbackFunction = myActionsFunction || (refreshedProject.functions ? refreshedProject.functions[0] : null);

        if (fallbackFunction) {
          dispatch(selectMyActionsProjectFunction(fallbackFunction));
        }
      });
    }
  } catch (error) {
    dispatch(showSnackBarMessage("Error Importing Procedures"));

    dispatch({
      type: PROJECT_FUNCTION_IMPORT_PROCEDURES_ERROR,
      payload: error,
    });
  }
};

const importFunctionProcedureCategories = (
  { projectId, functionId, categories },
  onComplete = () => { }
) => async (dispatch, getState) => {
  let webServices = new WebServices();
  dispatch({ type: PROJECT_FUNCTION_IMPORT_PROCEDURES });

  try {
    const projects = await webServices.importFunctionProcedureCategories({ projectId, functionId, categories });
    dispatch(showSnackBarMessage("Procedures Imported Successfully"));

    dispatch({
      type: PROJECT_FUNCTION_IMPORT_PROCEDURES_SUCCESS,
      payload: projects,
    });

    const selectedFunction = getState().projects.selectedFunction;
    if (selectedFunction && selectedFunction.id) {
      await dispatch(selectFunction(selectedFunction, { forceReload: true }));
    }

    const { selectedProjectOrGbu, selectedFunctionDetails } = getState().projects;
    const canSyncWorkflow =
      selectedProjectOrGbu &&
      !selectedProjectOrGbu.isGbu &&
      selectedProjectOrGbu.id &&
      selectedFunction &&
      selectedFunction.id &&
      selectedFunctionDetails &&
      Array.isArray(selectedFunctionDetails.workflowSteps);

    if (canSyncWorkflow) {
      const formValues = {
        workflowSteps: selectedFunctionDetails.workflowSteps,
        projectShouldAutoApproveProcedures:
          selectedFunctionDetails.projectShouldAutoApproveProcedures,
      };

      try {
        await dispatch(
          updateProjectWorkflowApprovers(
            formValues,
            selectedProjectOrGbu.id,
            () => { },
            { suppressSuccessMessage: true }
          )
        );
      } catch (workflowSyncError) {
        // Error toast is handled in updateProjectWorkflowApprovers.
      }
    }

    onComplete(true);
  } catch (error) {
    dispatch(showSnackBarMessage("Error Importing Procedures"));

    dispatch({
      type: PROJECT_FUNCTION_IMPORT_PROCEDURES_ERROR,
      payload: error,
    });
    onComplete(false);
  }
};

const addProject = (project) => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: PROJECTS_ADD });

  webServices
    .addProject(project)
    .then((project) => {
      dispatch(showSnackBarMessage("Project Added Successfully"));

      dispatch({ type: PROJECTS_ADD_SUCCESS, payload: project });
    })
    .catch((error) => {
      dispatch({ type: PROJECTS_ADD_ERROR, payload: error });
    });
};

const deleteIWPPApproverStep = (id, completion = () => { }) => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: PROJECTS_DELETE_IWPP_APPROVER });

  webServices
    .deleteIWPPAproverStep(id)
    .then(({ result, errorMessage }) => {
      dispatch(showSnackBarMessage("Step Deleted", errorMessage));
      completion(true);
      dispatch({
        type: PROJECTS_DELETE_IWPP_APPROVER_SUCCESS,
        payload: result,
      });
    })
    .catch((error) => {
      completion(false);

      dispatch({ type: PROJECTS_DELETE_IWPP_APPROVER_ERROR, payload: error });
    });
};

const updateIWPPWorkflowApprovers = (formValues, gbuId, completion) => (
  dispatch,
  getState
) => {
  const webServices = new WebServices();

  const workflowStepsToUpdate = formValues.workflowSteps.map(
    (workflowStep) => ({
      id: workflowStep.id,
      primaryUserBun: workflowStep.primary ? workflowStep.primary.bun : null,
      proxyUserBun: workflowStep.proxy ? workflowStep.proxy.bun : null,
      stepLabel: workflowStep.stepLabel,
    })
  );
  dispatch({
    type: PROJECTS_UPDATE_IWPP_APPROVERS,
    payload: { workflowStepsToUpdate, gbuId },
  });

  webServices
    .updateIWPPAprovers(workflowStepsToUpdate, gbuId)
    .then((updatedGbuDetails) => {
        // Removed duplicate success toast
      completion(true);
      dispatch({
        type: PROJECTS_UPDATE_IWPP_APPROVERS_SUCCESS,
        payload: updatedGbuDetails,
      });
    })
    .catch((error) => {
      dispatch(showSnackBarMessage("Error Updating Approvers"));
      completion(true);
      dispatch({
        type: PROJECTS_UPDATE_IWPP_APPROVERS_ERROR,
        payload: error,
      });
    });
};

const updateGbuWorkflowApprovers = (formValues, selectedGbuId) => (
  dispatch,
  getState
) => {
  const webServices = new WebServices();

  const functionId = getState().projects.selectedFunction.id;
  let workflowStepsToUpdate =
    functionId === 0
      ? formValues.workflowSteps
      : _.filter(
        formValues.workflowSteps,
        (step) =>
          step.stepScope === "GBU" ||
          step.stepScope === "IWPP" ||
          step.stepScope === "CORP"
      );

  workflowStepsToUpdate.forEach(function (workflowStep, index) {
    if (workflowStep.proxy && workflowStep.proxy.length === 0) {
      workflowStep.proxy = null;
    }
  });

  dispatch({
    type: PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS,
    payload: { workflowStepsToUpdate, selectedGbuId },
  });

  webServices
    .updateWorkflowApprovers({
      workflowStepsToUpdate,
      isGbu: true,
      id: selectedGbuId,
      functionId,
    })
    .then((updatedGbuDetails) => {
      dispatch({
        type: PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_SUCCESS,
        payload: updatedGbuDetails,
      });
      dispatch(showSnackBarMessage("Workflow saved successfully", null, 4000));
    })
    .catch((error) => {
      dispatch(showSnackBarMessage("Error Updating Approvers"));
      dispatch({
        type: PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_ERROR,
        payload: error,
      });
    });
};

const updateProjectWorkflowApprovers = (
  formValues,
  selectedProjectId,
  completion = () => { },
  options = {}
) => (dispatch, getState) => {
  const webServices = new WebServices();
  const { suppressSuccessMessage = false } = options;

  let workflowStepsToUpdate = _.filter(formValues.workflowSteps, {
    stepScope: "PROJECT",
  });

  workflowStepsToUpdate.forEach(function (workflowStep, index) {
    if (workflowStep.proxy && workflowStep.proxy.length === 0) {
      workflowStep.proxy = null;
    }
  });

  const functionId = getState().projects.selectedFunction.id;

  workflowStepsToUpdate = {
    workflowSteps: workflowStepsToUpdate,
    shouldAutoApproveProcedures: formValues.projectShouldAutoApproveProcedures,
  };

  dispatch({
    type: PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS,
    payload: { workflowStepsToUpdate, selectedProjectId },
  });

  return webServices
    .updateWorkflowApprovers({
      workflowStepsToUpdate,
      isGbu: false,
      id: selectedProjectId,
      functionId,
    })
    .then((updatedProjectDetails) => {
      dispatch({
        type: PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS,
        payload: updatedProjectDetails,
      });
      if (!suppressSuccessMessage) {
        dispatch(showSnackBarMessage("Workflow saved successfully"));
      }
      const { selectedFunction } = getState().projects;
      if (selectedFunction && selectedFunction.id) {
        dispatch(selectFunction(selectedFunction, { forceReload: true }));
      }
      completion(true);
      return updatedProjectDetails;
    })
    .catch((error) => {
      dispatch({
        type: PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_ERROR,
        payload: error,
      });
      completion(false);
      dispatch(showSnackBarMessage("Error Updating Approvers"));
      throw error;
    });
};

const updateProject = (project) => (dispatch, getState) => {
  let projectToUpdate = getState().projects.selectedProjectOrGbu;

  let webServices = new WebServices();
  dispatch({ type: PROJECTS_UPDATE_PROJECT });

  webServices
    .updateProject({ projectToUpdate })
    .then((project) => {
      dispatch(showSnackBarMessage("Project Updated"));
      dispatch({ type: PROJECTS_UPDATE_PROJECT_SUCCESS, payload: project });
    })
    .catch((error) => {
      dispatch(showSnackBarMessage("Error Updating Project"));
      dispatch({ type: PROJECTS_UPDATE_PROJECT_ERROR, payload: error });
    });
};

const fetcProjectSpecificProcedures = (projectId, functionId) => async (dispatch) => {
  let webServices = new WebServices();

  if (projectId) {
    let projectSpecificProcedures = await webServices.getProjectSpecificProcedures({ gbuId: null, projectId, functionId });
    dispatch({
      type: PROCEDURES_FETCH_SUCCESS,
      payload: {
        procedures: projectSpecificProcedures,
        isProjectSpecific: true,
        // projectSpecificCorporateProcedures,
      },
    });

  }
};

export {
  importFunctionProcedureCategories,
  updateGbuWorkflowApprovers,
  deleteIWPPApproverStep,
  updateProjectWorkflowApprovers,
  fetchProjects,
  selectProject,
  selectGbu,
  selectFunction,
  editFunctions,
  saveProjectFunctions,
  addProject,
  importFunctionProcedures,
  updateIWPPWorkflowApprovers,
  updateProject,
  fetcProjectSpecificProcedures
};
